import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {TextAlignment} from '../../../../../types/createStylesParams'
import {textEnumMetadata} from '../../../../../utils/builderMetadata'

export type LayoutSettingsParams = {
  textAlignment: SettingsParamType.String
}

export const layoutSettingsParams = createSettingsParams<LayoutSettingsParams>({
  textAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Center,
    metadata: textEnumMetadata(
      {defaultValue: TextAlignment.Center},
      'Alignment of the confirmation page text: left, center or right',
    ),
  },
})
